import general from "../general";
import { sortEncodeAndHash } from "./signFunc";
import { storageLocal } from "../view/util/storage";

// 是否信息流判断 及 bd_vid获取
const getUuidCallback = async () => {
  const timeCall = new Date().getTime().toString();

  let objData = {
    agent: localStorage.getItem("agent"),
  };

  await general.axios
    .post("/ocpc/NoticeDepart", objData, {
      headers: {
        sign: sortEncodeAndHash({
          ...objData,
          timestamp: timeCall,
        }),
        timestamp: timeCall,
        appid: "991701",
      },
    })
    .then(async (res) => {
      console.log(res);

      if (res?.data?.data?.isCallback) {
        storageLocal.set("jjAgentShow", "open");

        if (!storageLocal.has("tgm_uuid")) {
          const time = new Date().getTime().toString();
          console.log("没有tgm_uuid激活-----------");

          let objData = {
            account_type: "baidu_xs",
            package_name: "com.xt.xuantian",
            vid: storageLocal.get("bd_vid"),
            agent: localStorage.getItem("agent"),
          };

          await general.axios
            .post("/ocpc/getVid", objData, {
              headers: {
                sign: sortEncodeAndHash({
                  ...objData,
                  timestamp: time,
                }),
                timestamp: time,
                appid: "991701",
              },
            })
            .then((res) => {
              console.log("获取bd_vid------", res);

              if (res?.data?.data?.vid) {
                storageLocal.set("tgm_uuid", res.data.data.vid);
                if (!storageLocal.has("boxFirstKid")) {
                  storageLocal.set("boxFirstKid", res.data.data.vid);
                }
              }
            })
            .catch((error) => console.log("media-point " + error));
        }
      } else {
        storageLocal.remove("jjAgentShow");
        storageLocal.remove("tgm_uuid");
        storageLocal.remove("bd_vid");
      }
    })
    .catch((error) => console.log("media-point " + error));
};

// 信息流行为上报
const behaviorTrigger = (type, params) => {
  const time = new Date().getTime().toString();

  let objData = {
    vid: storageLocal.get("tgm_uuid"),
    action: type,
    agent: localStorage.getItem("agent"),
    ...params,
  };

  general.axios
    .post("/ocpc/reportVid", objData, {
      headers: {
        sign: sortEncodeAndHash({
          ...objData,
          timestamp: time,
        }),
        timestamp: time,
        appid: "991701",
      },
    })
    .then((res) => {
      console.log(res);
    })
    .catch((error) => console.log("游戏详情访问回传--- " + error));
};

// 分包短vid获取
const getShortVidCallback = async () => {
  let shortVid = "";

  const time = new Date().getTime().toString();
  let objData = {
    vid: storageLocal.get("tgm_uuid"),
  };

  await general.axios
    .post("/ocpc/handleVid", objData, {
      headers: {
        sign: sortEncodeAndHash({
          ...objData,
          timestamp: time,
        }),
        timestamp: time,
        appid: "991701",
      },
    })
    .then((res) => {
      console.log("分包短vid获取---", res);
      shortVid = res?.data?.data?.uuid;
    })
    .catch((error) => console.log("media-point " + error));

  return shortVid;
};

export { getUuidCallback, behaviorTrigger, getShortVidCallback };
